module.exports = __webpack_public_path__ + "static/46-8c51985cd271878866a1bdaf20818d21.png";